import { atomWithStorage, createJSONStorage } from 'jotai/utils';
//import { atom } from "jotai";
import { MenteesProps } from '../types';

export interface UserRoles {
  isHR: boolean;
  isMentor: boolean;
}

export interface UserProps {
  selectedMentee?: MenteesProps;
  activeNav: string;
  loading: boolean;
  error: boolean;
  cycleId: string;
  quarterId: string;
}

export interface globalProps {
  userRole: UserRoles;
  loggedIn: boolean;
  userInfo?: {
    id: string;
    mentor: {
      id: string;
      name: string;
      email: string;
      designation: string;
      tier: number | string;
    } | null;
    tier: string;
    designation: string;
  };
}

// initials state for user
export const userState: UserProps = {
  activeNav: '2',
  loading: true,
  error: false,
  cycleId: '',
  quarterId: '',
};

// initials state for global
export const globalState: globalProps = {
  userRole: {
    isHR: false,
    isMentor: false,
  },
  loggedIn: false,
};

const globalAtom = atomWithStorage<globalProps>('atomStore', globalState);
//const userAtom = atom<UserProps>(userState);
const userAtom = atomWithStorage<UserProps>(
  'userAtomStore',
  userState,
  createJSONStorage(() => window.sessionStorage)
);

export { globalAtom, userAtom };
